import styled from 'styled-components';

export const Main = styled.div`
  display: grid;
  grid-auto-columns: auto 5fr;
`;

export const FilterWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: 1;
  }
`;

export const ProductListingWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-column: 2;
  }
`;

export const FilterSection = styled.div`
  margin-right: 10px;
  border-radius: 5px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin: 0 auto;
  }
`;

export const FilterSectionSticky = styled(FilterSection)`
  /* position: sticky; */
  top: 200px;
`;

export const ProductListingContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 20px;
  ${({ theme }) => theme.breakpoints.down('xl')} {
    grid-template-columns: 1fr 1fr 1fr;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    grid-template-columns: 1fr;
    padding: 1% 0%;
  }
  position: relative;
`;

export const FetchMoreSection = styled.div`
  position: absolute;
  padding: 10px;
  bottom: 1000px;
  left: 0;
  right: 0;
`;

export const FetchMoreLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const NoProductsFound = styled.div`
  padding: 25px;
`;

export const ProductListingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  margin-bottom: 4px;
`;

export const TaxonTitle = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.black || '#333'};
`;

export const ProductListingBodyWrapper = styled.div`
  margin-top: 10px;
`;
